import "./src/styles/reset.css";
import "./src/styles/variables.css";
import "./src/styles/global.css";

// Lägg till denna rad så att Decap CMS inte initieras automatiskt
export const onClientEntry = () => {
  window.CMS_MANUAL_INIT = true;
};
